import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";
import { toast } from 'react-toastify';

export const GetDemoApprovalsWT = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getDemoApprovalsWT(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_DEMO_CERTIFY_APPROVALS_WT, payload: data.data });
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};

export const DecideDemoApprovalWT = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.decideDemoApprovalWT(formData);
    if (status === 200) {
      toast.success(data.message);
    } else {
      toast.error(data.message);
      dispatch({ type: actionTypes.SET_ERRORS, payload: data.message });
    }
    setLoading(false);
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to record decision");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
};
